// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  close: () => 'Uždaryti',
  error: () => 'Klaida',
  warn: () => 'Perspėjimas',
  info: () => 'Informacija',
  confirmation: () => 'Patvirtinimas',
  progressIndeterminate: () => 'Vykdoma',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Tarp ' + p['FROM_SECTION'] + '  ir ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nerasta jokių atitinkančių skyrių.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Norėdami pasirinkti reikšmę, paspauskite Enter.',
  indexer_touchInstructionText: () =>
    'Du kartus spustelėkite ir palaikykite, kad įjungtumėte gestų režimą, tada vilkite aukštyn arba žemyn, kad koreguotumėte reikšmę.',
  inputPassword_show: () => 'Rodyti slaptažodį',
  inputPassword_hide: () => 'Slėpti slaptažodį',
  inputPassword_hidden: () => 'Slaptažodis paslėptas',
  formControl_clear: () => 'Valyti',
  formControl_loading: () => 'Įkeliama',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Viršytas maksimalus ilgis ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' simboliai (-ių) liko.',
  formControl_requiredMessageDetail: () => 'Įveskite reikšmę.',
  select_requiredMessageDetail: () => 'Pasirinkite reikšmę.',
  select_noMatchesFound: () => 'Atitikmenų nerasta.',
  select_oneMatchFound: () => 'Rastas vienas atitikmuo',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Rasta ' + p['TOTAL_SIZE'] + ' atitikmenų',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Rasta ' + p['TOTAL_SIZE'] + ' arba daugiau atitikmenų',
  selectMultiple_selectedValues: () => 'Parinktos reikšmės',
  selectMultiple_showSelectedValues: () => 'Rodyti tik pasirinktas reikšmes.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Pasirinkta reikšmių: ' + p['VALUE_COUNT'] + '.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Paspauskite Grįžti arba Naikinti, kad pašalintumėte pasirinktą reikšmę.',
  selectMultiple_apply: () => 'Taikyti',
  selectMultiple_back: () => 'Atgal',
  selector_selected: () => 'Žymės langelis pažymėtas',
  selector_unselected: () => 'Žymės langelis nepažymėtas',
  userAssistance_learnMore: () => 'Sužinokite daugiau',
  userAssistance_required: () => 'Būtina',
  filePicker_singleFileUploadError: () => 'Vienu kartu galima įkelti vieną failą',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    p['fileType'] + ' tipo failų įkelti negalima',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Šio tipo failų įkelti negalima: ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'nežinoma',
  filePicker_dropzonePrimaryText: () => 'Nuvilkimas',
  filePicker_dropzoneSecondaryText: () => 'Pasirinkite failą arba jį nuvilkite čia',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Pasirinkite arba nuvilkite failus čia',
  filePicker_addFiles: () => 'Įtraukti failų',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Padidinti',
  inputNumber_decrease: () => 'Sumažinti',
  inputNumber_converterParseError: () => 'Įveskite skaičių.',
  noData_message: () => 'Nėra rodytinų elementų',
  message_navigationFromMessagesRegion: () =>
    'Įeinama į pranešimų sritį. Paspauskite F6, kad grįžtumėte prie ankstesnio pasirinkto elemento.',
  message_navigationToMessagesRegion: () =>
    'Pranešimų srityje yra naujų pranešimų. Paspauskite F6, kad grįžtumėte prie naujausių pranešimų srities.',
  messageToast_allMessagesClosed: () => 'Visi informaciniai pranešimai uždaryti.',
  expandableList_groupCollapse: () => 'Sutraukta',
  expandableList_groupExpand: () => 'Išskleista',
  expandableList_expandCollapseInstructionText: () =>
    'Naudokite rodyklių klavišus norėdami išskleisti ir sutraukti',
  list_suggestion: () => 'Pasiūlymas',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    p['currentStep'] + ' žingsnis iš ' + p['numberOfSteps'],
  train_current: () => 'Dabartinis',
  train_visited: () => 'Aplankyta',
  train_not_visited: () => 'Neaplankyta',
  train_message_type: () => 'Pranešimo tipas',
  viz_drillable: () => 'Kilmė analizuojama',
  dataVisualization_stateSelected: () => 'Pasirinkta',
  dataVisualization_stateUnselected: () => 'Nepasirinkta',
  dataVisualization_noData: () => 'Nėra rodytinų duomenų'
};
export default bundle;
